export function OutlineCalendarXIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.01465 9.99805H21.0146V19.0028C21.0146 20.1068 20.1218 20.9996 19.0178 20.9996H5.01144C3.90745 20.9996 3.01465 20.1068 3.01465 19.0028V9.99805Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M5.01144 5.00195H19.0178C20.1218 5.00195 21.0146 5.89475 21.0146 6.99875V10.0035H3.01465V6.99875C3.01465 5.89475 3.90745 5.00195 5.01144 5.00195Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M7.01318 6.99839V3"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M17.0161 6.99839V3"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M13.9347 13.5801L10.0947 17.4201"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0947 13.5801L13.9347 17.4201"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
